import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bff71b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qrcode" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { onMounted, onBeforeMount, ref, computed } from "vue";
import SvgIcon from "@component/SvgIcon/index.vue";
import { Popover } from "ant-design-vue";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const isShowToTop = ref(false);
const toTop = () => {
  window.scrollTo({
    left: 0,
    top: 0,
    behavior: "smooth",
  });
};
const windowScroll = () => {
  // 超过一屏才显示去顶部按钮，一屏即window.innerHeight
  isShowToTop.value = window.scrollY >= window.innerHeight;
};
onMounted(() => {
  window.addEventListener("scroll", windowScroll);
});
onBeforeMount(() => {
  window.removeEventListener("scroll", windowScroll);
});
const isShowFloatTip = computed(() => {
  if (["DownLoad"].indexOf(route.name) !== -1) {
    return false;
  } else {
    return true;
  }
});

return (_ctx: any,_cache: any) => {
  return (_unref(isShowFloatTip))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["floatTip", { isShowToTop: isShowToTop.value }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(Popover), {
            placement: "left",
            overlayClassName: "qrcode-popover"
          }, {
            content: _withCtx(() => [
              _createElementVNode("img", {
                class: "google-qrcode-hover",
                src: require('@/assets/img/qrcode-GooglePlay.png'),
                alt: ""
              }, null, 8, _hoisted_2)
            ]),
            default: _withCtx(() => [
              _createVNode(SvgIcon, {
                class: "google-qrcode",
                name: "down_btn_icon_googleplay",
                size: 30,
                style: {"cursor":"pointer"}
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(Popover), {
            placement: "left",
            overlayClassName: "qrcode-popover"
          }, {
            content: _withCtx(() => [
              _createElementVNode("img", {
                class: "google-qrcode-hover",
                src: require('@/assets/img/qrcode-Appstore.png'),
                alt: ""
              }, null, 8, _hoisted_3)
            ]),
            default: _withCtx(() => [
              _createVNode(SvgIcon, {
                name: "down_btn_icon_ios",
                size: 30,
                style: {"cursor":"pointer"}
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["to-top", { active: isShowToTop.value }]),
          onClick: toTop
        }, [
          _createVNode(SvgIcon, {
            name: "icon-top",
            size: 30,
            style: {"cursor":"pointer"}
          })
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}
}

})